/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} VarietalInputs */

const en_varietal = /** @type {(inputs: VarietalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Varietal`)
};

const es_varietal = /** @type {(inputs: VarietalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Varietal`)
};

/**
* | output |
* | --- |
* | "Varietal" |
*
* @param {VarietalInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const varietal = /** @type {((inputs?: VarietalInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<VarietalInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_varietal(inputs)
	return es_varietal(inputs)
});